import { MsgHandler } from './../../core/app/msg/msgHandler';
import * as consts from './../../core/app/common/consts';
import { ClsArmService } from '../../core/app/asp/cls-arm.service';
import { AppInjector } from '../../core/app/common/inject';
import { AppConfig } from '../../core/app/app.config';

export class ClsArmHandler extends MsgHandler {
  private static _self: ClsArmHandler = null;

  private constructor() {
    super(consts.MSG_TYPE_CLSARM);
  }

  public static getSelf(): ClsArmHandler {
    if (this._self == null)
      this._self = new ClsArmHandler();
    return this._self;
  }

  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs)
      console.log("clsarm msg:", msgObj);
    AppInjector.get(ClsArmService).fillData(msgObj);
  }
}
